import { createFeature, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { Content } from '../../domain/content/content.model';
import { closeInlineContent, loadInlineContent, openInlineContent } from './dn-dialog.actions';

// Stato dell'apertura contenuti "in pagina" (sotto la card cliccata).
// Estratto dal reducer dynamic-container per essere riusato da qualunque pagina
// contenitore (minisito, periodico, ...). Le action e l'effect con la pipeline
// permessi restano in dn-dialog.actions/effects (già globali).
export interface InlineContentState {
	content: Content | undefined;
	urlToDownload: string | undefined;
	urlWithContext: string | undefined;
	template: string | undefined;
	anchorElementId: string | undefined;
	loading: boolean;
}

export const inlineContentInitialState: InlineContentState = {
	content: undefined,
	urlToDownload: undefined,
	urlWithContext: undefined,
	template: undefined,
	anchorElementId: undefined,
	loading: false
};

export const INLINE_CONTENT_FEATURE_NAME: string = 'inlineContent';

export const inlineContentReducer = createReducer(
	inlineContentInitialState,
	on(loadInlineContent, (state, { anchorElementId }) => ({
		...inlineContentInitialState,
		anchorElementId,
		loading: true
	})),
	on(openInlineContent, (state, { content, urlToDownload, urlWithContext, template, anchorElementId }) => ({
		content,
		urlToDownload,
		urlWithContext,
		template,
		anchorElementId,
		loading: false
	})),
	on(closeInlineContent, () => ({ ...inlineContentInitialState }))
);

export const inlineContentFeature = createFeature({
	name: INLINE_CONTENT_FEATURE_NAME,
	reducer: inlineContentReducer
});

export const selectInlineContentState =
	createFeatureSelector<InlineContentState>(INLINE_CONTENT_FEATURE_NAME);

export const selectInlineContent = createSelector(
	selectInlineContentState,
	(state: InlineContentState) => state
);

export const selectInlineContentLoading = createSelector(
	selectInlineContentState,
	(state: InlineContentState) => state?.loading
);
